/** Defines the React context for the onboarding hint priority queue. */
// @ts-check
import { createContext } from 'react';

/** @typedef {{ priority: number, eligible: boolean, body: string, title?: string, testId?: string, onDismiss: () => void, dismissTabIndex?: number }} HintQueueEntry */

/**
 * @typedef {Object} OnboardingHintQueueContextValue
 * @property {boolean} enabled
 * @property {string | null} activeId
 * @property {(id: string, entry: HintQueueEntry | null) => void} setRegistration
 */

/** @type {import('react').Context<OnboardingHintQueueContextValue | null>} */
export const OnboardingHintQueueContext = createContext(null);
